import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  Stack,
  Link,
  Fab,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"; // Importing the up arrow icon
import Image from "../../../images/Image";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const [showScroll, setShowScroll] = useState(false);
  const navigate = useNavigate();
  const isTesting = process.env.NODE_ENV === "test";

  const goTohome = () => {
    navigate(`/`);
    handleScrollToTop();
  };
  // Function to scroll to the top
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Show or hide the scroll button based on window scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const menuItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Solutions", href: "/solutions" },
    { label: "Product", href: "/solutions/product-detail/storm/11" },
    { label: "Case Studies", href: "/casestudy" },
  ];
  const supportUsLinks = [
    { label: "FAQs", href: "#" },
    { label: "Contact Us", href: "/contact" },
    { label: "Support Center", href: "#" },
    { label: "Security", href: "#" },
  ];
  return (
    <Box
      sx={{
        background: "#00254E",
        paddingTop: 15,
      }}
    >
      <Stack>
        <Box
          sx={{
            background: "#00254E",
            position: "relative", // Ensure the parent is relatively positioned for the absolute child
          }}
        >
          <Stack sx={{ display: { xs: "none", sm: "flex", md: "flex" } }}>
            <Box
              sx={{
                position: "absolute", // Absolutely position the element
                bottom: "62px", // Position it at the bottom of the parent
                left: "50%", // Center horizontally
                transform: "translate(-50%, -50%)", // Fine-tune centering
                zIndex: 10,
              }}
            >
              <Box
                sx={{
                  padding: 0.5,
                  backgroundColor: "#E3E5E4",
                  borderRadius: "50px",
                }}
              >
                <IconButton
                  aria-label="Scroll to top"
                  onClick={scrollToTop}
                  sx={{
                    backgroundColor: "#fff",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    borderRadius: "30px",
                    padding: "25px",
                    color: "blue",
                  }}
                >
                  <KeyboardArrowUpIcon
                    sx={{
                      fontSize: "35px !important", // Width is set here
                      height: "35px !important", // Height adjustment
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Stack>

      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 4, sm: 8 },
          py: { xs: 8, sm: 10 },
          maxWidth: { md: "100% !important" },
          width: { md: "inherit !important" },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Grid container spacing={2} sx={{ width: { md: "100%" } }}>
          {/* 1. Office Address Section */}
          <Grid
            size={{ xs: 12, sm: 2 }}
            order={{ xs: 2, sm: 4 }}
            className="sh-footer-links office-address"
          >
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
              className="sh-footer-links office-address"
            >
              <Typography className="stonehand-footer-menuli-lbl">
                Office Address
              </Typography>
              <Typography
                className="stonehand-footer-menuli-lbl country"
                sx={{ textTransform: "uppercase" }}
              >
                India
              </Typography>
              <Typography className="stonehand-footer-offc-addr-menuli">
                #123/3 Mettukuppam Main Road,Maduravoyal, Chennai,- 600 095.
                Tel: +918220002200
              </Typography>
              <Typography
                className="stonehand-footer-menuli-lbl country"
                sx={{ textTransform: "uppercase" }}
              >
                Srilanka
              </Typography>
              <Typography className="stonehand-footer-offc-addr-menuli">
                #3/3, Rajakiya Mawatha Colombo-400 007. Tel: +94 778100119
              </Typography>
              <Typography
                className="stonehand-footer-menuli-lbl country"
                sx={{ textTransform: "uppercase" }}
              >
                Singapore
              </Typography>
              <Typography className="stonehand-footer-offc-addr-menuli">
                62 UBI ROAD 1, #11-08 OXLEY BIZHUB 2, S408734. Tel +6585223415
              </Typography>
              <Typography
                className="stonehand-footer-menuli-lbl country"
                sx={{ textTransform: "uppercase" }}
              >
                United Kingdom
              </Typography>
              <Typography className="stonehand-footer-offc-addr-menuli">
                Laxton House, Spalding PE11 3NP Tel: +44 7778748940
              </Typography>
            </Box>
          </Grid>

          {/* 2. Navigation Links */}
          <Grid
            size={{ xs: 12, sm: 2 }}
            order={{ xs: 2, sm: 2 }}
            className="sh-footer-links"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                paddingTop: { xs: 2, sm: 0, lg: 0, xl: 0, md: 0 },
                alignItems: {
                  xs: "center",
                  sm: "center",
                  md: "flex-start",
                  lg: "flex-start",
                },
              }}
            >
              <Typography className="stonehand-footer-menuli-lbl">
                Navigate
              </Typography>
              {menuItems.map((item, index) => (
                <React.Fragment key={item.label}>
                  <Link
                    className="stonehand-footer-menuli"
                    variant="body2"
                    href={item.href}
                  >
                    {item.label}
                  </Link>
                  {/* Add a divider below each link except the last one */}
                  {index < menuItems.length - 1 && (
                    <Box sx={{ width: "100%" }}>
                      <Divider
                        sx={{
                          width: 300,
                          display: { xs: "block", sm: "none" },
                        }}
                      />
                    </Box>
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Grid>

          {/* 3. Support Us Links */}
          <Grid
            size={{ xs: 12, sm: 2 }}
            order={{ xs: 3, sm: 3 }}
            className="sh-footer-links"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: {
                  xs: "center",
                  sm: "center",
                  md: "flex-start",
                  lg: "flex-start",
                },
                paddingTop: { xs: 2, sm: 0, lg: 0, xl: 0, md: 0 },
              }}
            >
              <Typography className="stonehand-footer-menuli-lbl">
                Support
              </Typography>
              {supportUsLinks.map((item, index) => (
                <React.Fragment key={item.label}>
                  <Link
                    className="stonehand-footer-menuli"
                    variant="body2"
                    href={item.href}
                  >
                    {item.label}
                  </Link>
                  {index < supportUsLinks.length - 1 && (
                    <Box sx={{ width: "100%" }}>
                      <Divider
                        sx={{
                          width: 300,
                          display: { xs: "block", sm: "none" },
                        }}
                      />
                    </Box>
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Grid>

          {/* 4. Footer Logo Section */}
          <Grid
            size={{ xs: 12, sm: 4 }}
            order={{ xs: 1, sm: 1 }}
            className="sh-footer-links"
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {!isTesting && (
                <Box
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => goTohome()}
                >
                  <Image.FooterLogo />
                </Box>
              )}
              <Typography variant="body2" sx={{ color: "#FFFFFF" }}>
                © stonehands
              </Typography>
              <Typography variant="body2" sx={{ color: "#FFFFFF" }}>
                www.stonehands.in
              </Typography>
              <Box sx={{ display: "flex", gap: 2, paddingTop: 3 }}>
                <IconButton
                  className="stonehand-soci-icon"
                  color="inherit"
                  size="small"
                  href="#"
                  aria-label="Instagram"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/stonehandsproject",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  {!isTesting && <Image.InstagramIcon />}
                </IconButton>
                <IconButton
                  className="stonehand-soci-icon"
                  color="inherit"
                  size="small"
                  href="#"
                  aria-label="Twitter"
                  onClick={() =>
                    window.open(
                      "https://x.com/stonehandsproj",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  {!isTesting && <Image.TwitterIcon />}
                </IconButton>
                <IconButton
                  className="stonehand-soci-icon"
                  color="inherit"
                  size="small"
                  href="#"
                  aria-label="Facebook"
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/share/1HEKhhfzZu/?mibextid=wwXIfr",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  {!isTesting && <Image.FacebookIcon />}
                </IconButton>
                <IconButton
                  className="stonehand-soci-icon"
                  color="inherit"
                  size="small"
                  href="#"
                  aria-label="YouTube"
                  onClick={() =>
                    window.open(
                      "https://www.youtube.com/@StoneHandsProject",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  {!isTesting && <Image.YoutubeIcon />}
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Section */}
        <Box
          p={5}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // Set flex direction based on screen size
            justifyContent: { xs: "center", sm: "space-between" }, // Adjust alignment
            alignItems: "center",
            color: "#FFFF",
            width: "100%",
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          {/* Typography with order property */}
          <Typography
            className="stonehand-footer-menuli"
            sx={{
              paddingTop: { xs: 2, sm: 0, md: 0, lg: 0, xl: 0 },
              order: { xs: 2, sm: 1 }, // Adjust order based on screen size
              textAlign: { xs: "center", sm: "left" }, // Center-align on smaller screens
              marginBottom: "10px",
            }}
          >
            © 2024 Stone Hands, All rights reserved
          </Typography>

          {/* Stack with links */}
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{
              cursor: "pointer",
              order: { xs: 1, sm: 2 }, // Adjust order based on screen size
              justifyContent: { xs: "center", sm: "flex-start" }, // Center-align on smaller screens
              flexWrap: "wrap", // Ensure wrapping on smaller screens
            }}
          >
            <Link
              className="stonehand-footer-menuli"
              variant="body2"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/policy/terms&conditions");
              }}
            >
              Terms & Conditions
            </Link>
            <Typography sx={{ display: "inline", mx: 0.5, opacity: 0.5 }}>
              &nbsp;| &nbsp;
            </Typography>
            <Link
              className="stonehand-footer-menuli"
              variant="body2"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/policy/privacy");
              }}
            >
              Privacy Policy
            </Link>
            <Typography sx={{ display: "inline", mx: 0.5, opacity: 0.5 }}>
              &nbsp;| &nbsp;
            </Typography>
            <Link
              className="stonehand-footer-menuli"
              variant="body2"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/policy/cookie");
              }}
            >
              Cookies Policy
            </Link>
            <Typography sx={{ display: "inline", mx: 0.5, opacity: 0.5 }}>
              &nbsp;| &nbsp;
            </Typography>
            <Link className="stonehand-footer-menuli" variant="body2" href="#">
              Sitemap
            </Link>
          </Stack>
        </Box>
      </Container>

      {/* Scroll-to-Top Button */}
      {showScroll && (
        <Fab
          aria-label="Scroll to top"
          color="primary"
          size="small"
          onClick={handleScrollToTop}
          sx={{
            display: "none",
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 1000,
            backgroundColor: "#0065FF",
            "&:hover": {
              backgroundColor: "#0055CC",
            },
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      )}
    </Box>
  );
}
